import { sportClubBoardTypeService } from '@/services/api/sportClubBoardType.service';
import { sportClubBoardTypeModel } from '@/models/api/sportClubBoardType.model';
import { alertHelper, sharedHelper } from '@/utils';
import i18n from '@/i18n';

export const SPORT_CLUB_BOARD_TYPE_MODULE = 'api/sportClubBoardType';
export const GET_ALL_SPORT_CLUB_BOARD_TYPE = 'getAllSportClubBoardType';
export const GET_SPORT_CLUB_BOARD_TYPE = 'getSportClubBoardType';
export const CREATE_SPORT_CLUB_BOARD_TYPE = 'createSportClubBoardType';
export const UPDATE_SPORT_CLUB_BOARD_TYPE = 'updateSportClubBoardType';
export const UPDATE_SPORT_CLUB_BOARD_TYPE_STATUS = 'updateSportClubBoardTypeStatus';

export const state = {
    list: { data: [], pagination: { pageNumber: 1, pageSize: 10, total: 0 } },
    details: null,
    status: { list: true, detail: true, save: true },
    errors: { list: '', detail: '', save: '' },
    listRequest: 0,
};

export const actions = {
    async [GET_ALL_SPORT_CLUB_BOARD_TYPE]({ commit, state }, { filter } = {}) {
        commit('requesting', 'list');
        const request = state.listRequest;
        try {
            const response = await sportClubBoardTypeService.getAll(filter);
            if (request === state.listRequest) commit('listed', response);
            return response?.data || response;
        } catch (error) {
            if (request === state.listRequest) commit('failed', { type: 'list', error: sharedHelper.getErrorMessage(error) });
            return null;
        } finally {
            if (request === state.listRequest) commit('finished', 'list');
        }
    },
    async [GET_SPORT_CLUB_BOARD_TYPE]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const response = await sportClubBoardTypeService.show(uuid);
            const result = response?.data || response;
            commit('detailed', result);
            return result;
        } catch (error) {
            commit('failed', { type: 'detail', error: sharedHelper.getErrorMessage(error) });
            return null;
        } finally {
            commit('finished', 'detail');
        }
    },
    async [CREATE_SPORT_CLUB_BOARD_TYPE]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubBoardTypeService.store(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.created') });
            await dispatch(GET_ALL_SPORT_CLUB_BOARD_TYPE, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
    async [UPDATE_SPORT_CLUB_BOARD_TYPE]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubBoardTypeService.update(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.updated') });
            await dispatch(GET_ALL_SPORT_CLUB_BOARD_TYPE, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
    async [UPDATE_SPORT_CLUB_BOARD_TYPE_STATUS]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const response = await sportClubBoardTypeService.updateStatus(data);
            const result = response?.data || response;
            alertHelper.alertSuccess({ message: i18n.t('sports.statusUpdated') });
            await dispatch(GET_ALL_SPORT_CLUB_BOARD_TYPE, { filter });
            return result;
        } catch (error) {
            const msg = sharedHelper.getErrorMessage(error);
            alertHelper.alertError({ message: msg, title: i18n.t('message.error') });
            commit('failed', { type: 'save', error: msg });
            return null;
        } finally {
            commit('finished', 'save');
        }
    },
};

export const mutations = {
    requesting(state, type) {
        state.status[type] = false;
        state.errors[type] = '';
        if (type === 'list') state.listRequest++;
        if (type === 'detail') state.details = null;
    },
    finished(state, type) { state.status[type] = true; },
    failed(state, { type, error }) { state.errors[type] = error; },
    clearSaveError(state) { state.errors.save = ''; },
    listed(state, result) {
        const list = Array.isArray(result)
            ? result
            : (Array.isArray(result?.data) ? result.data : []);
        state.list.data = list.map(sportClubBoardTypeModel);
        const pagination = (!Array.isArray(result) && result?.pagination) ? result.pagination : {};
        state.list.pagination = sharedHelper.apiPaginationAdapter(pagination);
    },
    detailed(state, result) {
        const detail = (result && result.data && !result.uuid) ? result.data : result;
        state.details = detail ? sportClubBoardTypeModel(detail) : null;
    },
};
